import imageData from "./ImageData";
const data = [
  {
    title: "How big is your app?",
    dataArray: [
      {
        heading: "01",
        logoText: "Small",
        imageSrc: imageData.small,
        imageSrc1: imageData.smalls,
        description1: "Your app probably has around 2-3 key feature screens",
        description2: " (excluding any static content, sign in, sign up etc.)",
      },
      {
        heading: "02",
        logoText: "Medium",
        imageSrc: imageData.medium,
        imageSrc1: imageData.mediums,
        description1: "Your app probably has around 4-7 key feature screens",
        description2: " (excluding any static content, sign in, sign up etc.)",
      },
      {
        heading: "3",
        logoText: "Large",
        imageSrc: imageData.large,
        imageSrc1: imageData.larges,
        description1: "Your app probably has around 8-12 key feature screens",
        description2: " (excluding any static content, sign in, sign up etc.)",
      },
    ],
  },

  {
    title: "What level of UI would you like?",
    dataArray: [
      {
        heading: "01",
        logoText: "MVP",
        imageSrc: imageData.MVP,
        imageSrc1: imageData.MVPs,
        description1:
          "Design based on UI kit with minimal branding, able to fulfill key operations.",
        description2: " ",
      },
      {
        heading: "02",
        logoText: "Basic",
        imageSrc: imageData.Basic,
        imageSrc1: imageData.Basics,
        description1: "Partial use of UI kit + customized design.",
        description2: " ",
      },
      {
        heading: "3",
        logoText: "Polished",
        imageSrc: imageData.polished,
        imageSrc1: imageData.polisheds,
        description1:
          "Fully customized design that doesn't/almost doesn't use ready-made solutions.",
        description2: " ",
      },
    ],
  },
  {
    title: "Users & Accounts",
    dataArray: [
      {
        heading: "01",
        logoText: "Email / Password Sign Up",
        imageSrc: imageData.email,
        imageSrc1: imageData.emails,
        description1: "Ability to log in using Email and password.",
        description2: " ",
      },
      {
        heading: "02",
        logoText: "Facebook Sign Up",
        imageSrc: imageData.fb,
        imageSrc1: imageData.fbs,
        description1: "Ability to log in using Facebook profile.",
        description2: " ",
      },
      {
        heading: "03",
        logoText: "Twitter Sign Up",
        imageSrc: imageData.twitter,
        imageSrc1: imageData.twitters,
        description1: "Ability to log in using Twitter profile.",
        description2: " ",
      },
      {
        heading: "04",
        logoText: "Google Sign Up",
        imageSrc: imageData.google,
        imageSrc1: imageData.googles,
        description1: "Ability to log in using Google account.",
        description2: " ",
      },
      {
        heading: "05",
        logoText: "Linkedin Sign Up",
        imageSrc: imageData.linkedin,
        imageSrc1: imageData.linkedins,
        description1: "Ability to log in using LinkedIn profile.",
        description2: " ",
      },
      {
        heading: "06",
        logoText: "Github Sign Up",
        imageSrc: imageData.github,
        imageSrc1: imageData.githubs,
        description1: "Ability to log in using Github account.",
        description2: " ",
      },
      {
        heading: "07",
        logoText: "User Invitation Emails",
        imageSrc: imageData.invite,
        imageSrc1: imageData.invites,
        description1: "Opportunity to invite a user to try your App.",
        description2: " ",
      },
      {
        heading: "08",
        logoText: "Multi-tenant Accounts",
        imageSrc: imageData.multi,
        imageSrc1: imageData.multis,
        description1:
          "Architecture in which a single instance of a software app serves multiple customers.",
        description2: " ",
      },
      {
        heading: "09",
        logoText: "Subdomains",
        imageSrc: imageData.domain,
        imageSrc1: imageData.domains,
        description1: "An additional section of your main domain name.",
        description2: " ",
      },
      {
        heading: "10",
        logoText: "Custom Domains",
        imageSrc: imageData.Basic,
        imageSrc1: imageData.Basics,
        description1: "A unique branded name that identifies a website.",
        description2: " ",
      },
    ],
  },
  {
    title: "User Generated Content",
    dataArray: [
      {
        heading: "01",
        logoText: "Dashboard",
        imageSrc: imageData.dashboard,
        imageSrc1: imageData.dashboards,
        description1: "Data visualization using the information panel.",
        description2: " ",
      },
      {
        heading: "02",
        logoText: "Activity Feed",
        imageSrc: imageData.activity,
        imageSrc1: imageData.activitys,
        description1:
          "List of recent activities performed by an individual on a  website.",
        description2: " ",
      },
      {
        heading: "03",
        logoText: "Media Uploading",
        imageSrc: imageData.media,
        imageSrc1: imageData.medias,
        description1:
          "Tool that allows users to upload content to a specific media library.",
        description2: " ",
      },
      {
        heading: "04",
        logoText: "User Profiles",
        imageSrc: imageData.profile,
        imageSrc1: imageData.profiles,
        description1:
          "Collection of settings and information associated with a user.",
        description2: " ",
      },
      {
        heading: "05",
        logoText: "Transactional Emails",
        imageSrc: imageData.temail,
        imageSrc1: imageData.temails,
        description1:
          "Email that's triggered by a user action on a website or mobile app.",
        description2: " ",
      },
      {
        heading: "06",
        logoText: "Tags",
        imageSrc: imageData.tags,
        imageSrc1: imageData.tagss,
        description1:
          "The process of providing data taxonomy to group similar things.",
        description2: " ",
      },
      {
        heading: "07",
        logoText: "Ratings or reviews",
        imageSrc: imageData.rating,
        imageSrc1: imageData.ratings,
        description1:
          "Empowers customers to share their opinions and experiences.",
        description2: " ",
      },
      {
        heading: "08",
        logoText: "MMedia Manipulation",
        imageSrc: imageData.media_edit,
        imageSrc1: imageData.media_edits,
        description1:
          "Tool that allows to carry out manipulations on processing media files.",
        description2: " ",
      },
      {
        heading: "09",
        logoText: "Searching",
        imageSrc: imageData.search,
        imageSrc1: imageData.searchs,
        description1:
          "AnSoftware system that is designed to carry out search through inside your app.",
        description2: " ",
      },
    ],
  },
  {
    title: "Dates & Locations",
    dataArray: [
      {
        heading: "01",
        logoText: "Calendaring",
        imageSrc: imageData.calendar,
        imageSrc1: imageData.calendars,
        description1:
          "Provide information about events related to you or your business.",
        description2: " ",
      },
      {
        heading: "02",
        logoText: "Display of Map data",
        imageSrc: imageData.map,
        imageSrc1: imageData.maps,
        description1:
          "Display your data as locations or other geographic information in the form of shape, path, and symbol elements on an interactive map",
        description2: " ",
      },
      {
        heading: "03",
        logoText: "Geolocation",
        imageSrc: imageData.geo,
        imageSrc1: imageData.geos,
        description1:
          "Device-based data collection relies on GPS and cellular networks.",
        description2: " ",
      },
      {
        heading: "04",
        logoText: "Bookings",
        imageSrc: imageData.booking,
        imageSrc1: imageData.bookings,
        description1:
          "Convenient way of finding and booking your service over the internet.",
        description2: " ",
      },
    ],
  },

  {
    title: "Social & Engagement",
    dataArray: [
      {
        heading: "01",
        logoText: "Messaging",
        imageSrc: imageData.msg,
        imageSrc1: imageData.msgs,
        description1:
          "The messaging channels you currently use to engage and communicate with app users.",
        description2: " ",
      },
      {
        heading: "02",
        logoText: "Forums or commenting",
        imageSrc: imageData.forum,
        imageSrc1: imageData.forums,
        description1:
          "System that exists not only for feedback, but also for users communication.",
        description2: " ",
      },
      {
        heading: "03",
        logoText: "Social Sharing",
        imageSrc: imageData.social,
        imageSrc1: imageData.socials,
        description1:
          "Collective of online communications channels dedicated to content-sharing.",
        description2: " ",
      },
      {
        heading: "04",
        logoText: "Push to Facebook Open Graph",
        imageSrc: imageData.push_fb,
        imageSrc1: imageData.push_fbs,
        description1:
          "Integration between Facebook and its user data and a website.",
        description2: " ",
      },
      {
        heading: "05",
        logoText: "Push Notifications",
        imageSrc: imageData.push,
        imageSrc1: imageData.pushs,
        description1:
          "Information delivery from a software application without a specific request from the client.",
        description2: " ",
      },
    ],
  },

  {
    title: "Billing & eCommerce",
    dataArray: [
      {
        heading: "01",
        logoText: "Subscription plans",
        imageSrc: imageData.card,
        imageSrc1: imageData.cards,
        description1:
          "Allows to charge your subscribers/viewers monthly or yearly, set up automatic renewals and offer free trials.",
        description2: " ",
      },
      {
        heading: "02",
        logoText: "Shopping Cart",
        imageSrc: imageData.shopping,
        imageSrc1: imageData.shoppings,
        description1:
          'Software that keeps a record of the items a buyer has "picked up" from the online store.',
        description2: " ",
      },
      {
        heading: "03",
        logoText: "User Marketplace",
        imageSrc: imageData.market,
        imageSrc1: imageData.markets,
        description1:
          "Ability to buy from many different sources. The operator of the marketplace does not own any inventory, their business is to present other people's inventory to a user and facilitate a transaction.",
        description2: " ",
      },
      {
        heading: "04",
        logoText: "In-App Purchasing",
        imageSrc: imageData.in_app,
        imageSrc1: imageData.in_apps,
        description1:
          'Ability of devices to facilitate the sale of products or services within a specific application or "app."',
        description2: " ",
      },
      {
        heading: "05",
        logoText: "Payment Information Collection",
        imageSrc: imageData.pay_info,
        imageSrc1: imageData.pay_infos,
        description1:
          "Enables your signers to provide credit card payment information securely.",
        description2: " ",
      },
      {
        heading: "06",
        logoText: "Payment processing",
        imageSrc: imageData.pay_proc,
        imageSrc1: imageData.pay_procs,
        description1:
          "Processes and services that automate payment transactions between the shopper and merchant.",
        description2: " ",
      },
      {
        heading: "07",
        logoText: "Product Management",
        imageSrc: imageData.prod_m,
        imageSrc1: imageData.prod_ms,
        description1:
          "Helps to set the strategy, roadmap, and feature definition for a product or product line.",
        description2: " ",
      },
    ],
  },

  {
    title: "Admin, Feedback & Analytics",
    dataArray: [
      {
        heading: "01",
        logoText: "CMS Integration",
        imageSrc: imageData.cms,
        imageSrc1: imageData.cmss,
        description1:
          "Software that are used to create and manage digital content.",
        description2: " ",
      },
      {
        heading: "02",
        logoText: "User Admin pages",
        imageSrc: imageData.forum,
        imageSrc1: imageData.forums,
        description1:
          "Full access to manage the site including adding, deleting and editing all pages and modules.",
        description2: " ",
      },
      {
        heading: "03",
        logoText: "Moderation / Content Approval",
        imageSrc: imageData.admin,
        imageSrc1: imageData.admins,
        description1:
          "Allows to assign moderator to approve or reject content submitted by users before publishing.",
        description2: " ",
      },
      {
        heading: "04",
        logoText: "Support",
        imageSrc: imageData.support,
        imageSrc1: imageData.supports,
        description1:
          "Accessibility to communication at any time and quick response to problems.",
        description2: " ",
      },
      {
        heading: "05",
        logoText: "Usage Analytics",
        imageSrc: imageData.analytics,
        imageSrc1: imageData.analyticss,
        description1:
          "Provides information on how a product or service is being used.",
        description2: " ",
      },
      {
        heading: "06",
        logoText: "Crash Reporting",
        imageSrc: imageData.warn,
        imageSrc1: imageData.warns,
        description1:
          "Software which identify reporting crash details and to alert when there are crashes.",
        description2: " ",
      },
      {
        heading: "07",
        logoText: "Performance Monitoring",
        imageSrc: imageData.perf,
        imageSrc1: imageData.perfs,
        description1:
          "Ability to determine how well fast applications are running.",
        description2: " ",
      },
      {
        heading: "08",
        logoText: "Multilingual Support",
        imageSrc: imageData.multi_lang,
        imageSrc1: imageData.multi_langs,
        description1:
          "Allows you to use different, translated versions of your Support Center content for 53 different languages.",
        description2: " ",
      },
    ],
  },

  {
    title: "External APIs and Integrations Hours",
    dataArray: [
      {
        heading: "01",
        logoText: "Connect to one or more third party services",
        imageSrc: imageData.party,
        imageSrc1: imageData.partys,
        description1:
          "Allows you to access third-party companies functionality via code and use it on your site.",
        description2: " ",
      },
      {
        heading: "02",
        logoText: "An API for others to integrate with your app",
        imageSrc: imageData.api,
        imageSrc1: imageData.apis,
        description1:
          "Interface that allows you to integrate the functionality of applications on other platforms.",
        description2: " ",
      },
      {
        heading: "3",
        logoText: "SMS Messaging",
        imageSrc: imageData.sms,
        imageSrc1: imageData.smss,
        description1: "Mailing, verification and other functions using SMS.",
        description2: " ",
      },
      {
        heading: "04",
        logoText: "Phone Number Masking",
        imageSrc: imageData.phone,
        imageSrc1: imageData.phones,
        description1:
          "Technique used to protect buyers' and sellers' personal phone numbers private.",
        description2: " ",
      },
    ],
  },

  {
    title: "Security Hours",
    dataArray: [
      {
        heading: "01",
        logoText: "SSL Certificate based Security",
        imageSrc: imageData.ssl,
        imageSrc1: imageData.ssls,
        description1:
          "Data files that digitally bind a cryptographic key to an organization's details.",
        description2: " ",
      },
      {
        heading: "02",
        logoText: "DDoS protection",
        imageSrc: imageData.ddos,
        imageSrc1: imageData.ddoss,
        description1:
          "Set of techniques or tools for resisting or mitigating the impact of distributed denial-of-service.",
        description2: " ",
      },
      {
        heading: "3",
        logoText: "Two Factor Authentication",
        imageSrc: imageData.security,
        imageSrc1: imageData.securitys,
        description1:
          "Method in which the user is granted access only after successfully presenting two or more pieces of evidence.",
        description2: " ",
      },
    ],
  },

  {
    title: "App Specific Development Hours",
    dataArray: [
      {
        heading: "01",
        logoText: "App Specific Development",
        imageSrc: imageData.dev,
        imageSrc1: imageData.devs,
        description1: "Customized apps that meet the unique needs.",
        description2: " ",
      },
      {
        heading: "02",
        logoText: "Project Manager",
        imageSrc: imageData.pm,
        imageSrc1: imageData.pms,
        description1:
          "Planning and organizing the resources necessary to complete a project.",
        description2: " ",
      },
    ],
  },
];

export default data;
